import { entryNav } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function EntryNav() {
  return (
    <section id="entry" className="w-full border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <SectionHeading
          kicker="DIRECTORY"
          title="专区入口汇总"
          desc="黑料福利入口、地址与板块集中在一页，选一个专区即可直达，不用反复搜索。"
          actionLabel="全部 16 个通道"
          actionHref="#entry"
        />

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-2 lg:grid-cols-4">
          {entryNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="group flex cursor-pointer flex-col bg-background-50 p-5 transition-colors hover:bg-primary-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-500">{item.count} 条</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.name}</h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                进入专区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}